import { render, staticRenderFns } from "./ThankYouEcommerce.vue?vue&type=template&id=12a858b7"
import script from "./ThankYouEcommerce.vue?vue&type=script&lang=js"
export * from "./ThankYouEcommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports